import { createRoot } from "@wordpress/element";
import React, { createContext, useContext, useReducer, useEffect } from "react";
import App from "./App";
import "./style.css";
import { v4 as uuidv4 } from "uuid";

// const domNode = document.getElementById("chatbort");
// const root = createRoot(domNode);

// root.render(<App />);

// create root container where react element will be inserted
let container = document.createElement("div");
container.classList.add("react-container");

// attach shadow DOM to container
const shadowRoot = container.attachShadow({ mode: "open" });

// create react element
// const reactButton = <button>Submit</button>;
const style = document.createElement("style");
style.textContent = `

@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.chatbot-container {
  /* position: fixed; */
  /* bottom: 20px; */
  /* right: 20px; */

  border: 1px solid #ddd;
  /* border-radius: 8px; */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  overflow: hidden;
  transition: transform 0.3s ease;
  font-family: "Poppins";
  transition: all 0.5s ease-in-out;

  @media (max-width: 768px) {
    // max-width: 100%;
    // width: 100%;
    // height: 100%;
    // top: 0;
    bottom: 20px;
    right: 20px;
    position: fixed;
  }
}

.chatbot-container.open {
  /* position: fixed; */
  /* bottom: 20px; */
  /* right: 20px; */
  transform: translateY(0);
  /* 20px plus the 20px from the bottom */
  height: calc(100vh - 40px);
  max-width: 450px;
  width: 450px;



  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    position: absolute;
  }
}

.chatbot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
   padding: 10px; 
  /* background-color: #007bff; */
  /* background: var(--Gold, #b78242); */
  color: white;
  cursor: pointer;
  font-family: "Poppins";
}

.chatbot-header button {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  font-family: "Poppins";
}

.chatbot-body {
  display: flex;
  flex-direction: column;
  height: calc(100% - 134px);
  background: #F2F5FA;
}

.chatbot-messages {
  flex: 1;
  padding: 20px;
  overflow-y: scroll;
  background-color: #F2F5FA;
  @media (max-width: 768px) {
    display: flex;  
    flex-direction: column;
  }
}

.message-container {
  margin-bottom: 30px;
}

.user-message .message {
  border-radius: 7px;
  background: #004334;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  // display: flex;
  width: 350px;
  padding: 15px;
  align-items: flex-start;
  gap: 10px;
  color: var(--White, #fff);

  /* Body */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.16px;
  font-family: "Poppins";

  @media (max-width: 768px) {
    width: calc(100% - 20px);
  }
}

.chatbot-message {
  float: left;
  @media (max-width: 768px) {
    float: none;
  }
}

.user-message {
  float: right;
  @media (max-width: 768px) {
    float: none;
  }
}

.chatbot-message .message {
  // display: flex;
  width: 350px;
  padding: 15px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  color: #666;

  /* Body */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.16px;

  @media (max-width: 768px) {
    width: calc(100% - 20px);
  }
}

.message {
    display: inline-block;
    max-width: 100%;
    word-break: break-word;
}

.timestamp {
  color: #666;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.12px;
  margin-top: 10px;
}

.chatbot-message > .timestamp {
  text-align: left;
}

.user-message > .timestamp {
  text-align: right;
}

.chatbot-placeholder {
  text-align: center;
  color: #888;
  padding: 20px;
}

.chatbot-input {
  padding: 10px;
  border-top: 1px solid #ddd;
  background-color: white;
  height: calc(25% - 40px);
  max-height: calc(25% - 40px);
  background-color: #F2F5FA;
}

.exit-cta {
  text-align: center;
  background-color: #F2F5FA;
  display: flex;
  padding: 20px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 14px;
  position: relative;
}

.exit-cta button {
	color: inherit;
  background: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exit-cta .exit-message {
  color: var(--Green, #004334);
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.14px;
}

.chat-input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 5px;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.chat-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 8px 12px;
  font-size: 16px;
  border-radius: 20px;
}

.chat-submit-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 8px;
  color: #555;
  position: absolute;
  right: 10px;
}

.chat-submit-button:hover {
  color: #000;
}

.cta-button {
  background: var(--Pale-Gold, #FFFBF5);
  color: var(--Gold, #B78242);
}

.cta-button:hover {
  color: var(--Pale-Gold, #FFFBF5);
  background: var(--Gold, #B78242);
}

.loading-dots {
  padding: 0px 5px;
  background-color: #FFF;
  border-radius: 50px;
  width: 62px;
  height: 28px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.loading-dots span {
  display: inline-block;
  animation: blink 0.4s infinite alternate;
  font-size: 1.5rem;
  background-color: #2f5f52;
  height: 12px;
  width: 12px;
  border-radius: 100%;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.1s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.2s;
}

@keyframes blink {
  from {
    opacity: 0.5;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(-1px);
  }
}

.Prompt {
  -webkit-animation: fadeIn 0.25 ease;
  animation: fadeIn 0.25 ease;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  margin: 16px;
  width: 100%;
  max-width: 317px;
  padding-top: 20px;
  position: fixed;
  // bottom: 75px;
  bottom: 119px;
  right: 10px;
}

.Prompt__CloseButton {
  background-color: hsla(0, 0%, 100%, 0.9);
  border-radius: 99999px;
  border: none;
  color: #767676;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 15px;
  margin-right: 3px;
  margin-bottom: 4px;
  
}

.Prompt__MessageBubble {
  border: 1px solid #e8e9eb;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.24);
  position: relative;
  background: #fff;
  border-radius: 13px;
  box-sizing: border-box;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  flex-direction: row;
  max-width: 290px;
  padding: 24px;
  width: 100%;
  z-index: 99999;
}

.Prompt__PromptText {
  font-size: 16px;
  line-height: 1.5;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
}

.Prompt__PromptText img {
  height: 40px;
  width: 40px;
}
`;

const initialState = {
  sessionId: null,
  token: null,
  messageHistory: [],
  languageCode: "en",
};

const GlobalStoreContext = createContext();

function globalStoreReducer(state, action) {
  switch (action.type) {
    case "INIT_SESSION": {
      let sessionId;
      if (
        sessionStorage.getItem("sessionId") === null ||
        sessionStorage.getItem("sessionId") === undefined
      ) {
        const uuid = uuidv4();
        sessionId = `dfMessenger-${uuid}`;
        sessionStorage.setItem("sessionId", sessionId);
      }

      sessionId = sessionStorage.getItem("sessionId");
      return { ...state, sessionId };
    }
    case "SET_MESSAGE_HISTORY": {
      sessionStorage.setItem("messageHistory", JSON.stringify(action.payload));
      return { ...state, messageHistory: action.payload };
    }
    case "SET_LANGUAGE_CODE": {
      return { ...state, languageCode: action.payload };
    }
    case "CLEAR_SESSION": {
      sessionStorage.clear();
      return {
        sessionId: null,
        messageHistory: [],
        token: null,
        languageCode: "en",
      };
    }
    default:
      return state;
  }
}

export const GlobalStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalStoreReducer, initialState);

  useEffect(() => {
    if (performance.getEntriesByType("navigation")[0]?.type === "reload") {
      sessionStorage.clear();
      dispatch({ type: "CLEAR_SESSION" });
    }

    const savedSessionId = sessionStorage.getItem("sessionId");
    const savedMessageHistory =
      JSON.parse(sessionStorage.getItem("messageHistory")) || [];

    if (savedSessionId) {
      dispatch({ type: "INIT_SESSION" });
    } else {
      dispatch({ type: "INIT_SESSION" });
    }

    if (savedMessageHistory) {
      dispatch({ type: "SET_MESSAGE_HISTORY", payload: savedMessageHistory });
    }
  }, []);

  const getSessionId = () => state.sessionId;
  const getMessageHistory = () => state.messageHistory;

  const setMessageHistory = (messages) => {
    dispatch({ type: "SET_MESSAGE_HISTORY", payload: messages });
  };

  const clearMessageHistory = () => {
    sessionStorage.clear();
    dispatch({ type: "CLEAR_SESSION" });
  };

  const setLanguageCode = (languageCode) => {
    dispatch({ type: "SET_LANGUAGE_CODE", payload: languageCode });
  };

  const getLanguageCode = () => state.languageCode;

  return (
    <GlobalStoreContext.Provider
      value={{
        sessionId: state.sessionId,
        messageHistory: state.messageHistory,
        getSessionId,
        getMessageHistory,
        setMessageHistory,
        clearMessageHistory,
        setLanguageCode,
        getLanguageCode,
      }}
    >
      {children}
    </GlobalStoreContext.Provider>
  );
};

export const useGlobalStore = () => {
  const context = useContext(GlobalStoreContext);
  if (!context) {
    throw new Error("useGlobalStore must be used within a GlobalStoreProvider");
  }
  return context;
};

// Append the style tag inside Shadow DOM
shadowRoot.appendChild(style);
// get hold of an existing element in HTML DOM
const domElement = document.getElementById("chatbort");

// insert root container element in HTML DOM after the existing element
domElement.after(container);

// shadow DOM as react root
const root = createRoot(shadowRoot);

// render react element inside shadow DOM
root.render(
  <GlobalStoreProvider>
    <App />
  </GlobalStoreProvider>
);
